module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete_bundle":"Delete Bundle","delete_bundle_confirmation":"Are you sure you want to delete this item? This item will be deleted permanently.","redeemed":"Redeemed"},"id":{"delete_bundle":"Hapus Bundle","delete_bundle_confirmation":"Anda yakin ingin menghapus item ini? Item ini akan dihapus secara permanen.","redeemed":"Telah Ditebus"}}')
  delete Component.options._Ctor
}
